import * as React from 'react';
import Flex from 'antd/lib/flex';
import Text from 'antd/lib/typography/Text';
import { CaretDownOutlined } from '@ant-design/icons';
import { navFlexItemStyle } from '../../styles/globalStyles';
import { useSidebarColors } from '../../styles/themeMode';
import { Destination } from '../../../types/destinations';
import { DestinationCounter } from '../../appHome/DestinationCounter';

interface DropdownButtonContentProps {
    icon: React.ReactNode;
    text: React.ReactNode;
    showCaret?: boolean;
    containerStyle?: React.CSSProperties;
    textStyle?: React.CSSProperties;
    caretStyle?: React.CSSProperties;
    cursor?: React.CSSProperties['cursor'];
    destinations?: Destination[];
}

export const DropdownButtonContent: React.FC<DropdownButtonContentProps> = ({
    icon,
    text,
    showCaret = true,
    containerStyle,
    textStyle,
    caretStyle,
    cursor = 'pointer',
    destinations,
}) => {
    const sc = useSidebarColors();
    const showCounter = destinations && destinations.length > 1;
    return (
        <Flex
            align="center"
            gap={12}
            style={{
                cursor,
                padding: 8,
                paddingRight: 12,
                minWidth: 0,
                backgroundColor: sc.dropdownBg,
                ...containerStyle,
            }}
        >
            {icon}
            <Text
                style={{
                    ...navFlexItemStyle,
                    color: sc.text,
                    fontSize: 16,
                    fontWeight: 500,
                    ...textStyle,
                }}
                ellipsis
            >
                {text}
            </Text>
            {showCounter && <DestinationCounter destinations={destinations} size={24} countOnly />}
            {showCaret && <CaretDownOutlined style={{ color: sc.textMuted, fontSize: 16, ...caretStyle }} />}
        </Flex>
    );
};
